export default "__VITE_ASSET__a069e4b8__"